import UrlHandler from '../url-handler';
import LazyHelper from '../helpers/lazy-helper';

const InitFilterWidget = {
    init: function () {
        document.addEventListener("DOMContentLoaded", function () {
            let isEventListenerAttached = false;
            if (getScrollFromTopValue() <= 0) {
                loadFilterComponents();
            }
            else {
                isEventListenerAttached = true;
                window.addEventListener('scroll', loadFilterComponents);
            }

            function loadFilterComponents() {
                if (getScrollFromTopValue() <= 0) {
                    {
                        if (isEventListenerAttached) {
                            window.removeEventListener('scroll', loadFilterComponents);
                        }
                        let filterWidgetWrapper = document.getElementsByClassName('js-filter-widget')[0];

                        let jqueryScriptUrl = '/Scripts/libs/jquery.min.js';

                        if ('undefined' == typeof window.jQuery) {
                            if (!document.getElementById('jquery') && !LazyHelper.doesScriptExists(jqueryScriptUrl)) {
                                LazyHelper.addScriptFile(jqueryScriptUrl, 'jquery', true);
                            }
                        }

                        LazyHelper.waitJqueryToLoad(function () {
                            if (!document.getElementById('kendoall-script')) {
                                let kendoUrl = filterWidgetWrapper.getAttribute('data-kendoBaseUrl');

                                let ev1 = LazyHelper.addScriptFile(kendoUrl + '/js/kendo.all.min.js', 'kendoall-script', true);

                                LazyHelper.addCssFile(kendoUrl + '/styles/kendo.common-material.min.css', true);
                                LazyHelper.addCssFile(kendoUrl + '/styles/kendo.rtl.min.css', true);
                                LazyHelper.addCssFile(kendoUrl + '/styles/kendo.material.min.css', true);
                                LazyHelper.addCssFile(kendoUrl + '/styles/kendo.material.mobile.min.css', true);

                                ev1.onload = function () {
                                    applyCss();
                                    LazyHelper.addScriptFile('/Frontend-Assembly/SitefinityWebApp/Mvc/Scripts/FilterWidget/filter-widget.js', 'filterwidget-script', false);
                                    window.UrlHandler = new UrlHandler();
                                }
                            }
                        })
                    }
                };
            }

            function applyCss() {
                $(".filter-widget__wrapper").css("opacity", "1");

                $(".advanced-filter__btn span").on('click', function (e) {
                    $('.advanced-filter__content').toggleClass("show");

                    if ($('.advanced-filter__content').hasClass("show")) {
                        $(this).find("i").addClass('minus').removeClass('plus');
                    } else {
                        $(this).find("i").addClass('plus').removeClass('minus');
                    }
                });

                var openFilters = $(".btn.show-more");
                if (openFilters) {
                    openFilters.on('click', function (e) {
                        $('.filter-widget__wrapper.expandable').toggleClass("show");
                        if ($('.filter-widget__wrapper.expandable').hasClass("show")) {
                            $(this).addClass('show-more--open');
                        } else {
                            $(this).removeClass('show-more--open');
                        }
                    });
                }
            }

            function getScrollFromTopValue() {
                let filterWidget = document.getElementsByClassName('js-filter-widget');
                if (filterWidget.length > 0) {
                    let isMobile = window.matchMedia('(max-width: 700px)');
                    if (isMobile.matches) {
                        return filterWidget[0].getBoundingClientRect().top - 800;
                    }
                    else {
                        return filterWidget[0].getBoundingClientRect().top - 1000;
                    }
                }

                return 1;
            };
        });
    }
}

InitFilterWidget.init();